<div *ngIf="!chosenTeam">
	<div *ngIf="!teamLoading" class="team-select">
	    <div class="vert-center">
	        <div class="flex justify-center std-mb" *ngIf="chosenTeam && selected_team !== 'new' ">
	            <div class="flex flex-col items-center">
	                <img [src]="chosenTeam.team_image" width="100px" class="rounded-avatar" />
	                <strong>{{ selected_team == 'new' ? '':'#'+selected_team }}</strong>
	            </div>
	        </div>
	        <app-custom-team-selection 
	        	[(ngModel)]="selected_team"
	        	[items]="teamList"
	        	[placeholder]="'Choose a Team'"
	        	[isLoggedIn]="isLoggedIn"
	            optionKeyForValue="kt_team_id"
	            optionKeyForLabel="team_name"
	            (ngModelChange)="setTeam()"
	            (choseSpectate)="spectate()"
	            (auth)="toAuth()"></app-custom-team-selection>
	    </div>
	</div>
	<div *ngIf="teamLoading" class="team-load">
	    <p class="center-text">Retrieving Teams...</p>
	</div>
</div>
<!-- <div *ngIf="!isLoggedIn && !hideWarn" class="team-auth-remind w-max-300-p">
    <p>Have a registered team? <span class="sim-link" (click)="toAuth()">Log in to use it!</span></p>
    <div class="vert-center sm-ml" (click)="hideWarn = true">
        <span>X</span>
    </div>
</div> -->

<div *ngIf="chosenTeam" class="hrz-center">
	<div class="team-confirm">
		<div class="team-confirm-title hrz-between">
			<h1>Play as {{chosenTeam.kt_team_id === 'new' ? 'New Team' : 'Team #' + chosenTeam.kt_team_id}}</h1>
			<mat-icon (click)="clearTeam()" aria-hidden="false" aria-label="Clear Team">clear</mat-icon>
		</div>
		<div class="hrz-start">
            <app-team-name class="flex-1" [name]="chosenTeam.team_name" (nameChange)="updateTeamName($event)"></app-team-name>
	    </div>
		<!-- <div *ngIf="!loading" class="flex flex-col hrz-between w-max-300-p">
		    <h3>How many players on your team today?</h3>
		    <input class="num-players std-mb" type="number" [value]="numPlayers"
		        (input)="numPlayers = $event.target.value">
		</div> -->
		<!-- <div *ngIf="isLoggedIn && numPlayers && !loading">
		    <div class="player-card">
		        <h3 class="player-header">Player 1: You</h3>
		    </div>
		    <div *ngFor="let inv of invites; let i = index" class="player-card">
		        <div class="hrz-start">
		            <h3 class="player-header">Player {{i + 2}}:</h3>
		            <select class="player-select" (change)="setInvite(inv, $event.target.value)">
		                <option [value]="''">+ Invite Later</option>
		                <option *ngFor="let m of memberList" [value]="m.playerid"
		                    [selected]="inv.playerid === m.playerid">{{m.player_name}}</option>
		                <option [value]="'email'" [selected]="inv.inviteBy === 'email'">+ Invite by Email
		                </option>
		                <option [value]="'phone'" [selected]="inv.inviteBy === 'phone'">+ Invite by Text
		                </option>
		            </select>
		            <span class="closer" (click)="removeInvite(i)">X</span>
		        </div>
		        <app-contact-chooser *ngIf="inv.inviteBy === 'email' || inv.inviteBy === 'phone'"
		            [contactType]="inv.inviteBy" [lockContactType]="inv.inviteBy" [noSubmit]="true"
		            (updateContact)="updateContact(inv, $event)"></app-contact-chooser>
		    </div>
		    <div class="add-invite" (click)="addInvite()">
		        <mat-icon aria-hidden="false" aria-label="Plus Icon">add_circle_outline</mat-icon>
		        <span>Invite a Teammate</span>
		    </div>
		</div> -->
		<div class="team-load">
		    <button *ngIf="chosenTeam.team_name" class="join" (click)="addTeam()" [disabled]="loading">
		        <span *ngIf="!loading">Add This Team</span>
		        <span *ngIf="loading">Adding...</span>
		    </button>
		</div>
	</div>
</div>


